import { render, staticRenderFns } from "./epworth.vue?vue&type=template&id=3a35a160"
import script from "./epworth.vue?vue&type=script&lang=js"
export * from "./epworth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports